export default __webpack_public_path__ + "static/media/twenty-four.a5b0c275.png";